import React from "react";
import "./style.scss";

type InputErrorMsgProps = { errMsg: string }
const InputErrorMsg = ({ errMsg }: InputErrorMsgProps) => {
  return <div className="input-err-msg">{errMsg}</div>;
};

export default InputErrorMsg;
